// extracted by mini-css-extract-plugin
module.exports = {"heading":"SignIn_heading__2dHnR","heading_div":"SignIn_heading_div__2P_oL","linkStyle":"SignIn_linkStyle__3PvhW","lastUsedLwaButton":"SignIn_lastUsedLwaButton__2AyDh"};